import { X } from 'lucide-react'
import { GotALetterWizard } from '@/components/claim/GotALetterWizard'
import { FadeModal } from '@/components/ui/fade-modal'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function GotALetterModal({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  return (
    <FadeModal
      open={open}
      onClose={onClose}
      labelledBy="got-a-letter-title"
      panelClassName="max-w-lg"
    >
      <Card className="relative max-h-[min(90dvh,720px)] w-full overflow-y-auto border-0 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 z-10 rounded-lg p-2 text-muted transition hover:bg-surface hover:text-charcoal"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        <CardHeader className="space-y-2 pr-12">
          <CardTitle id="got-a-letter-title">Got a letter?</CardTitle>
          <CardDescription>Enter your letter code to claim ownership.</CardDescription>
        </CardHeader>
        <CardContent className="overflow-visible pt-2">
          <GotALetterWizard hideIntro onComplete={onClose} />
        </CardContent>
      </Card>
    </FadeModal>
  )
}
